import { styled, Box, Typography } from '@mui/material';

interface DetailPillProps {
  $isSelected?: boolean;
  $isUpdated?: boolean;
}

export const CostDetailsBoxStyled = styled(Box)({
  width: '100%',
  minHeight: '350px',
  '@media (min-width: 744px)': {
    display: 'flex',
    borderBottom: '1px solid #000',
  },
  justifyContent: 'space-between',
  paddingBottom: '40px',
});

export const PlanPremiumBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '48px 0px',
  margin: '0 auto',
  '@media (min-width: 992px)': {
    width: '304px',
    marginLeft: '88px',
    marginRight: '118px',
  },
  '@media (max-width: 743px)': {
    borderBottom: '1px solid #000',
    padding: '48px 0px 24px 0px',
    marginBottom: '24px',
  },
});

export const PremiumTextStyled = styled(Box)({
  '& h2': {
    fontSize: 46,
    fontWeight: 400,
  },
  height: '52px',
});

export const HsaEligibleBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: 20,
  padding: '18px 20px',
  width: '100%',
  height: '60px',
  borderRadius: 3,
  border: '1px solid #e8ab8d',
  backgroundColor: '#fefbf6',
});

export const CoverageLevelsBoxStyled = styled(Box)({
  '@media (min-width: 744px)': {
    display: 'flex',
    width: '374px',
    flexDirection: 'column',
    textAlign: 'left',
  },
  minHeight: '313px',
  padding: '24px',
  backgroundColor: '#fbfbfb',
  border: '2px solid #f5f5f5',
  borderRadius: '5px',
  '@media (max-width: 743px)': {
    '& .mobileCenter': {
      margin: 'auto',
      textAlign: 'center',
    },
  },
});

export const PremiumDetailSmall = styled('div')({
  '@media (min-width: 744px)': {
    textAlign: 'right',
  },
});

export const UppercaseTextStyled = styled(Typography)({
  fontSize: '10px',
  fontWeight: '400',
  fontStyle: 'normal',
  textTransform: 'uppercase',
}) as typeof Typography;

export const SpaceBetweenRow = styled('div')({
  '@media (min-width: 744px)': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0px',
  },
  padding: '12px 0px',
});

// shared styling
export const DetailPillStyled = styled(Box)<DetailPillProps>(
  ({ $isSelected, $isUpdated }) => ({
    border: '1px solid #e6e6e6',
    borderRadius: '4px',
    backgroundColor: $isSelected
      ? 'var(--system-success-600, #2A7527)'
      : $isUpdated
        ? 'var(--system-warning-100, #FFDBA1)'
        : 'var(--neutral-grey-200, #E6E6E6)',
    color: $isSelected ? '#FFFFFF' : 'inherit',
    padding: '4px 8px',
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '11px',
    letterSpacing: '1.5px',
    gap: '8px',
    textTransform: 'uppercase',
    '@media (max-width: 743px)': {
      display: 'block',
    },
  })
);

export const BoldTextStyled = styled(Typography)({
  fontSize: '16px',
  fontWeight: '600',
  '@media (max-width: 743px)': {
    padding: '8px 0px 4px',
  },
}) as typeof Typography;
